module.exports = __webpack_public_path__ + "static/media/All State 4.9c55165b.svg";